export class AuthoringNotImplemented {
}
